import { usePaintStore } from "../../state/paintStore";
import type { ToolId } from "../../state/paintStore";
import { ToolButton } from "./ToolButton";
import "./Toolbar.css";

interface ToolbarProps {
  onUndo: () => void;
  onRedo: () => void;
  canUndo: boolean;
  canRedo: boolean;
  onSave: () => void;
  onRequestClear: () => void;
}

const TOOLS: Array<{ id: ToolId; label: string; icon: string }> = [
  { id: "marker", label: "Marker", icon: "marker" },
  { id: "eraser", label: "Eraser", icon: "eraser" },
  { id: "bucket", label: "Fill", icon: "bucket" },
  { id: "shape", label: "Shapes", icon: "shape" },
  { id: "text", label: "Text", icon: "text" },
  { id: "image", label: "Image", icon: "image" },
];

export function Toolbar({
  onUndo,
  onRedo,
  canUndo,
  canRedo,
  onSave,
  onRequestClear,
}: ToolbarProps) {
  const activeTool = usePaintStore((s) => s.activeTool);
  const setActiveTool = usePaintStore((s) => s.setActiveTool);
  const togglePanel = usePaintStore((s) => s.togglePanel);
  const openPanel = usePaintStore((s) => s.openPanel);

  const handleSelect = (id: ToolId) => {
    setActiveTool(id);
    if (id === "image") togglePanel("images");
    else if (openPanel === "images") togglePanel("images");
  };

  return (
    <aside className="toolbar" aria-label="Tools">
      <div className="toolbar-group">
        {TOOLS.map((tool) => (
          <ToolButton
            key={tool.id}
            label={tool.label}
            icon={tool.icon}
            active={activeTool === tool.id}
            onClick={() => handleSelect(tool.id)}
          />
        ))}
      </div>
      <div className="toolbar-divider" />
      <div className="toolbar-group">
        <ToolButton
          label="Undo"
          icon="undo"
          disabled={!canUndo}
          onClick={onUndo}
        />
        <ToolButton
          label="Redo"
          icon="redo"
          disabled={!canRedo}
          onClick={onRedo}
        />
      </div>
      <div className="toolbar-divider" />
      <div className="toolbar-group">
        <ToolButton label="Save" icon="save" onClick={onSave} />
        <ToolButton label="Clear" icon="clear" onClick={onRequestClear} />
      </div>
    </aside>
  );
}
